import type { Constructor } from 'type-fest';

export const BinderHandler: ProxyHandler<object> = {
  get(target, p, receiver) {
    const propertyValue = Reflect.get(target, p, receiver);

    if (typeof propertyValue === 'function') Reflect.set(target, p, propertyValue.bind(target));

    return Reflect.get(target, p, receiver);
  },
};

export function makeBinded<T extends object, Arguments extends unknown[] = unknown[]>(Target: Constructor<T, Arguments>) {
  return (...args: Arguments) => new Proxy(new Target(...args), BinderHandler) as T;
}
